// types/platform.ts
export enum Platform {
    WEB = 'web',
    IOS = 'ios',
    ANDROID = 'android',
    TELEGRAM = 'telegram',
}

export interface PlatformCapabilities {
    hasHapticFeedback: boolean;
    hasPushNotifications: boolean;
    hasNativeAuth: boolean;
    supportsAppleSignIn: boolean;
    isNativeApp: boolean;
    isTelegramMiniApp: boolean;
}

export interface HapticFeedbackOptions {
    style?: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft';
    type?: 'success' | 'warning' | 'error';
}

export interface PushNotificationPermission {
    granted: boolean;
    denied: boolean;
    prompt: boolean;
}